import React, { useEffect, useRef, useState } from "react";

import { graphql, useStaticQuery } from "gatsby";
import { useSelector } from "react-redux";

import { isBusinessHours, onExternalContentEnabledChange } from "./chatButtonHelper";
import { ReactComponent as IconMessage18 } from "../../icons/icon/18/a-icon-message-18.svg";
import { ReactComponent as IconMessage24 } from "../../icons/icon/24/a-icon-message-24.svg";
import AdaptiveIcon from "../adaptiveIcon/adaptiveIcon";
import IconButton from "../button/iconButton";
import MediaLightbox from "../lightbox/mediaLightbox";

import "./chatButton.scss";

const ChatButton = () => {
  if (process.env.GATSBY_ENABLE_CHAT?.toLowerCase() !== "true") return null;

  const data = useStaticQuery(graphql`
    {
      kontentItemSiteSettings(system: {codename: {eq: "site_settings"}}) {
        elements {
          hide_chatbot {
            value {
              codename
            }
          }
        }
      }
    }
  `);

  const mediaModal = useRef(null);
  const [clientSide, setClientSide] = useState(false);
  const externalContentEnabled = useSelector((state) => (
    state.complianceConsent.externalContentEnabled
  ));
  const hideChatBot = data.kontentItemSiteSettings.elements.hide_chatbot.value.length > 0
  && data.kontentItemSiteSettings.elements.hide_chatbot.value[0].codename === "true";

  useEffect(() => {
    onExternalContentEnabledChange(mediaModal, !hideChatBot && externalContentEnabled);
  }, [externalContentEnabled]);

  useEffect(() => {
    setClientSide(true);
  }, []);

  if (!clientSide || !isBusinessHours() || externalContentEnabled || hideChatBot) {
    return null;
  }

  return (
    <>
      <IconButton
        onClick={() => {
          mediaModal.current.show();
        }}
        variant="dark"
        iconOnly
        className="chat-button"
      >
        <AdaptiveIcon sm={<IconMessage18 />} lg={<IconMessage24 />} />
      </IconButton>
      <MediaLightbox
        ref={mediaModal}
      />
    </>
  );
};

export default ChatButton;
